import React from "react";

import CopySVG from "../../../assets/media/svg/icons/copy.svg";
import CheckSVG from "../../../assets/media/svg/icons/check.svg";
// WP i18n
import { __ } from "@wordpress/i18n";

const ShareFullLink = () => {
  return (
    <div className="flex justify-center my-6">
        <div data-component="share-link" className="share-link share-full-link flex items-center">
            <button type="button"
                    className="share-link__btn share-full-link__btn btn btn--tertiary--blue btn--with-icon btn--with-icon--svg">
                <CopySVG/> {__("Partilhar simulação", "df-simulators")}
            </button>
            <div className="share-link__message share-full-link-message flex items-center h-full ms-3">
                <CheckSVG/> {__("Url de partilha copiado!", "df-simulators")}
            </div>
        </div>
      </div>
  );
};

export default ShareFullLink;
